import { PropertyOperations } from '@/services/endpoints/audiences';

/** The cdp_trait id used as matching trait for every Comuni list (seeded backend-side). */
export const FISCAL_CODE_TRAIT_ID = 'fiscal_code';

/** Name prefix of in-flight communication drafts: hidden from every Comuni listing. */
export const DRAFT_NAME_PREFIX = 'Comunicazione - ';
export const PHONE_TRAIT_ID = 'phone';
export const EMAIL_TRAIT_ID = 'email';

/** Filter operators offered in the Comuni composer (a subset of the audience builder). */
export const COMUNI_OPERATIONS: PropertyOperations = {
  TEXT: { operations: ['EQUALS', 'NOT_EQUALS', 'CONTAINS'] },
  NUMBER: { operations: ['EQUALS', 'NOT_EQUALS', 'GT', 'GTE', 'LT', 'LTE'], aggregations: [] },
  DATE: { operations: ['EQUALS', 'NOT_EQUALS', 'GT', 'GTE', 'LT', 'LTE'] },
  DATETIME: { operations: ['EQUALS', 'NOT_EQUALS', 'GT', 'GTE', 'LT', 'LTE'] },
};

export const COMUNI_TOPICS = ['strade', 'meteo', 'sisma', 'idrico', 'elettrico', 'eventi', 'rifiuti', 'tributi', 'sanita', 'neve'] as const;
export type ComuniTopic = (typeof COMUNI_TOPICS)[number];
